import React, { useState, memo } from "react";

import DeliveryHead from "../DeliveryHead";
import {
  Grid,
  Container,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";

import { Formik, Form, Field, ErrorMessage } from "formik";
import AuthInput from "../../../shared/authinput";
import MainButton from "../../../shared/Button";
// import RouteOrderDetails from "./RouteOrderDetails";
import PreviewOrder from "./PreviewOrder";
import { isValidPhoneNumber } from "react-phone-number-input";
import {
  PhoneInputsMain,
  CustomLabel,
} from "../../../shared/commonstyle/PhoneStyle";
import CommonPhoneInputs from "../../../shared/authinput/CommonPhoneInputs";
import AutocompleteLocations from "../../../shared/map/AutocompleteLocations";
import { AutocompleteMain } from "../../../shared/map/AutocompleteStyle";
import {
  RouteStepMain,
  InputFlexWrap,
  CheckBoxMain,
  ErrorSpan,
  ButtomWraper,
} from "../styles/RouteStepMainStyle";
import { RouteSecStopvalidation } from "../../../../helpers/validations/delivery/RouteSteps";

const RouteSecStop = ({ NavigateCallback }) => {
  const [PhoneError, SetPhoneError] = useState(false);
  const [StepsCount, SetStepsCount] = useState(1);
  const [ShowConfirmPage, SetShowConfirmPage] = useState(false);

  let cirText = "3 of 4";

  if (StepsCount === 2) {
    cirText = "4 of 5";
  } else if (StepsCount === 3) {
    cirText = "5 of 6";
  } else if (StepsCount === 4) {
    cirText = "6 of 7";
  } else if (StepsCount === 5) {
    cirText = "7 of 8";
  }

  const ShowPreviusPage = () => {
    NavigateCallback(false);
  };

  const handleSubmit = (values, { resetForm }) => {
    const { phoneNumber } = values;
    const isValid = isValidPhoneNumber(phoneNumber);
    if (!isValid) {
      SetPhoneError(true);
      return;
    } else {
      SetStepsCount((prevCount) => prevCount + 1);
      resetForm();
    }
  };

  const ShowConfirmRoute = () => {
    SetShowConfirmPage(true);
  };

  const handleChange = (value, event, form) => {
    SetPhoneError(false);
    if (event?.nativeEvent?.inputType === "deleteContentBackward" && !value) {
      event.preventDefault();
      return;
    }

    const isNonString = typeof value !== "string";
    if (isNonString || value === "") {
      form.setFieldValue("phoneNumber", value);
      form.setFieldError("phoneNumber", "");
    } else {
      const isValid = isValidPhoneNumber(value);
      form.setFieldValue("phoneNumber", value);
      form.setFieldError(
        "phoneNumber",
        isValid ? undefined : "Invalid phone number"
      );
    }
  };

  return (
    <>
      <>
        {!ShowConfirmPage && (
          <>
            <DeliveryHead
              Value={75}
              BackLink="/route-order-details"
              CenterText="Request a Route  &nbsp;  - &nbsp; Next Stop"
              StepText={cirText}
              MobileMainText="Request a Route"
              MobileSubText="Next Stop"
              MobileMoreText={true}
              haveCallBack={true}
              CallBackFun={ShowPreviusPage}
            />
            <RouteStepMain>
              <Container maxWidth="lg">
                <Grid
                  container
                  spacing={2}
                  justifyContent="center"
                  alignItems="center"
                >
                  <Grid item xs={12} md={10} lg={8}>
                    <Formik
                      initialValues={{
                        ContactName: "",
                        phoneNumber: "",
                        EmailAddress: "",
                        SelectType: "",
                        Location: "",
                        Notes: "",
                      }}
                      validationSchema={RouteSecStopvalidation}
                      onSubmit={handleSubmit}
                    >
                      {(formik) => (
                        <Form autocomplete="off">
                          <InputFlexWrap>
                            <Field
                              type="text"
                              name="ContactName"
                              label="Contact Name"
                              component={AuthInput}
                              placeholder="Enter your name"
                            />
                            {/* <Field
                              type="number"
                              name="PhoneNumber"
                              label="Phone Number"
                              component={AuthInput}
                              placeholder="Enter your number"
                            /> */}
                            <PhoneInputsMain
                              className={`AuthInputMain  ${
                                formik.touched.phoneNumber &&
                                formik.errors.phoneNumber &&
                                "is__error"
                              }`}
                            >
                              <CustomLabel>Phone Number</CustomLabel>
                              <Field name="phoneNumber">
                                {({ field, form }) => (
                                  <CommonPhoneInputs
                                    {...field}
                                    onChange={(value, event) =>
                                      handleChange(value, event, form)
                                    }
                                  />
                                )}
                              </Field>
                              <ErrorMessage
                                name="phoneNumber"
                                component="span"
                                className="error"
                              />
                            </PhoneInputsMain>
                          </InputFlexWrap>

                          <InputFlexWrap>
                            <Field
                              type="text"
                              name="EmailAddress"
                              label="Email Address"
                              component={AuthInput}
                              placeholder="Enter your email"
                            />
                            <CheckBoxMain>
                              <FormControl>
                                <FormLabel id="demo-radio-buttons-group-label">
                                  Select Type
                                </FormLabel>
                                <RadioGroup
                                  aria-labelledby="demo-radio-buttons-group-label"
                                  defaultValue=""
                                  name="SelectType"
                                  value={formik.values.SelectType}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                >
                                  <FormControlLabel
                                    value="Pickup"
                                    control={<Radio />}
                                    label="Pick-up"
                                  />
                                  <FormControlLabel
                                    value="Dropoff"
                                    control={<Radio />}
                                    label="Drop-off"
                                  />
                                </RadioGroup>
                              </FormControl>
                              {formik.touched.SelectType &&
                                formik.errors.SelectType && (
                                  <ErrorSpan>
                                    {formik.errors.SelectType}
                                  </ErrorSpan>
                                )}
                            </CheckBoxMain>
                          </InputFlexWrap>

                          <InputFlexWrap>
                            <AutocompleteMain className="AuthInputMain ">
                              <CustomLabel>
                                Pickup / Drop-off Location
                              </CustomLabel>
                              <Field name="Location">
                                {({ field, form }) => (
                                  <AutocompleteLocations
                                    {...field}
                                    form={form}
                                  />
                                )}
                              </Field>
                              <ErrorMessage
                                name="Location"
                                component="span"
                                className="error"
                              />
                            </AutocompleteMain>
                            <Field
                              type="text"
                              name="Notes"
                              label="Notes"
                              component={AuthInput}
                              placeholder="Any Notes here..."
                            />
                          </InputFlexWrap>
                          {PhoneError && (
                            <span
                              className="Phoneerror"
                              style={{
                                color: "red",
                                textTransform: "capitalize",
                              }}
                            >
                              Invalid phone number
                            </span>
                          )}
                          <ButtomWraper>
                            <MainButton
                              type="submit"
                              label="Add Next Stop"
                              border={true}
                              disabled={StepsCount === 5 ? true : false}
                            />
                            <MainButton
                              type="button"
                              label="Confirm Route"
                              onClick={ShowConfirmRoute}
                            />
                          </ButtomWraper>
                        </Form>
                      )}
                    </Formik>
                  </Grid>
                </Grid>
              </Container>
            </RouteStepMain>
          </>
        )}

        {ShowConfirmPage && (
          <PreviewOrder
            NavigateCallback={SetShowConfirmPage}
            StepsCount={StepsCount}
          />
        )}
      </>
    </>
  );
};

export default memo(RouteSecStop);
